
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import Index from "./pages/Index";
import Login from "./pages/Login";
import MagicLinkLogin from "./pages/MagicLinkLogin";
import Dashboard from "./pages/Dashboard";
import ChangePassword from "./pages/ChangePassword";
import Assistant from "./pages/Assistant";
import Documents from "./pages/Documents";
import Cases from "./pages/Cases";
import Search from "./pages/Search";
import Settings from "./pages/Settings";
import Welcome from "./pages/Welcome";
import About from "./pages/About";
import Features from "./pages/Features";
import NotFound from "./pages/NotFound";
import Help from "./pages/Help";
import Chat from "./pages/Chat";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/auth/magic-link",
    element: <MagicLinkLogin />,
  },
  {
    path: "/auth/callback",
    element: <Login />,
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/assistant",
    element: (
      <ProtectedRoute>
        <Assistant />
      </ProtectedRoute>
    ),
  },
  {
    path: "/documents",
    element: (
      <ProtectedRoute>
        <Documents />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cases",
    element: (
      <ProtectedRoute>
        <Cases />
      </ProtectedRoute>
    ),
  },
  {
    path: "/search",
    element: (
      <ProtectedRoute>
        <Search />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/chat",
    element: (
      <ProtectedRoute>
        <Chat />
      </ProtectedRoute>
    ),
  },
  {
    path: "/help",
    element: (
      <ProtectedRoute>
        <Help />
      </ProtectedRoute>
    ),
  },
  {
    path: "/welcome",
    element: <Welcome />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
